import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';

/**
 * Send Project Budget data to the client.
 * @see app/Http/Resources/Project/ProjectBudgetResource.php
 */
export class ProjectBudget {
  constructor(
    public readonly budgetedAllProjectCosts: Nullable<number>,
    public readonly incomeToDate: Nullable<number>,
    public readonly purchaseExpensesToDate: Nullable<number>,
    public readonly fixedExpensesToDate: Nullable<number>,
    public readonly repairExpensesToDate: Nullable<number>,
    public readonly expensesToDate: Nullable<number>,
    public readonly expensesProjected: Nullable<number>,
    public readonly expensesProjectedVarianceDollars: Nullable<number>,
    public readonly profitBudgeted: Nullable<number>,
    public readonly profitToDate: Nullable<number>,
    public readonly profitProjected: Nullable<number>,
    public readonly profitProjectedVarianceDollars: Nullable<number>,
  ) {}
}

defineTransform(ProjectBudget, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
